import { useCallback, useState } from "react";
import GuidedTour from "../UI/GuidedTour";
import classes from "../UI/GuidedTour.module.css";

const steps = [
  {
    target: "create-workflow",
    title: "Welcome to Guitar Charts",
    text: "Create custom guitar scale and arpeggio diagrams, refine your favourite fingerings, then download or share your finished charts. This quick tour introduces the Create stage.",
  },
  {
    target: "create-instrument",
    title: "Choose your instrument",
    text: "Choose from 6, 7 or 8-string guitars, bass and ukulele. Alternative tunings and custom instrument layouts are also supported.",
  },
  {
    target: "create-scale",
    title: "Choose your scale or arpeggio",
    text: "Select a predefined scale or arpeggio to automatically generate its fretboard positions.",
  },
  {
    target: "create-intervals",
    title: "Choose and highlight notes",
    text: "Select individual intervals to create your own patterns. Use the colour picker to highlight roots or other important notes.",
  },
  {
    target: "create-layout",
    title: "Arrange the notes",
    text: "Choose how the notes are distributed across the strings, including automatic layouts and different notes-per-string patterns.",
  },
  {
    target: "create-diagrams",
    title: "Explore your scale positions",
    text: "Guitar Charts automatically generates the available positions for your selected scale and layout. The first position is highlighted here; these diagrams are the starting points for your customised charts.",
  },
  {
    target: "create-refine",
    title: "Make the charts your own",
    text: "Continue to Refine, where you can discard unwanted fingerings, customise individual diagrams and add explanations. You can then create a complete PDF or download individual graphics. Finish this tour whenever you're ready; it won't move you to Refine.",
  },
];

// Keep tour navigation local: it must never rerender the chart generator or dispatch edits.
export default function CreateQuickTour() {
  const [active, setActive] = useState(false);
  const close = useCallback(() => setActive(false), []);
  return <>
    <button type="button" className={classes.start} onClick={() => setActive(true)}>
      Take a quick tour
    </button>
    {active && <GuidedTour steps={steps} onClose={close} />}
  </>;
}
